module.exports = "<div class=\"form-group parts-margin-left\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/parts/b-none/b-none.component.html
// module id = ./src/app/parts/b-none/b-none.component.html
// module chunks = main